<script>
    import { trainerTexts as texts } from './trainerTexts.js';
    export let lang = 'eng';
</script>

<header class="login__header">
    <div class="login__header__box">
        <h1 class="heading-primary">{texts[lang].header_primary}</h1>
        <h2 class="heading-secondary">
            <h2 class="heading-secondary">{texts[lang].header_secondary}</h2>
        </h2>
    </div>
</header>
